import React, {useEffect, useRef, useState} from 'react';
import Autocomplete from 'Components/search/subcomponents/autocomplete';

const Input = ({
                   placeholder,
                   buttonLabel,
                   searchButtonAlt,
                   searchCancelAlt,
                   autocompleteResultProducts,
                   autocompleteResultPages,
                   query,
                   onChange,
                   onKeyUp,
                   visible,
                   insideHeader,
                   renderStatic,
               }) => {
    const [value, setValue] = useState(() => query);
    const [displayAutocomplete, setDisplay] = useState(true);
    const inputRef = useRef(null);

    const onSubmit = (e) => {
        e.preventDefault();
        if (value !== query) {
            setDisplay(false);
            onChange(value);
        }
    };

    const submitAutocomplete = (inputQuery) => {
        if (inputQuery !== query) {
            setDisplay(false);
            setValue(inputQuery);
            onChange(inputQuery);
        }
    };

    const clickAutocomplete = (inputQuery) => {
        if (inputQuery !== query) {
            setDisplay(false);
            setValue(inputQuery);
            onChange(inputQuery);
        }
    };

    useEffect(() => {
        setTimeout(() => {
            insideHeader && visible && inputRef?.current?.focus();
        }, 100);
    }, [visible]);

    const handleKeyDown = (e) => {
        if (e.key && e.key === 'Escape') {
            e.preventDefault();
            setDisplay(false);
        }

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            e.stopPropagation();

            const suggestionsElements = inputRef?.current?.parentElement
                .querySelectorAll('.cmp-search__autocomplete-box .cmp-search__autocomplete-entry');
            if (suggestionsElements && suggestionsElements.length > 0) {
                suggestionsElements[0].focus();
            }
        }
    };

    const handleKeyUp = (e) => {
        if (e.keyCode === 13 || e.key === 'Escape' ) {
            setDisplay(false);
        } else {
            const suggestionsElements = inputRef?.current?.parentElement
                .querySelectorAll('.cmp-search__autocomplete-box .cmp-search__autocomplete-entry');
            if (suggestionsElements && suggestionsElements.length > 0) {
                inputRef?.current?.setAttribute('aria-label', 'Suchvorschläge gefunden');
            } else {
                inputRef?.current?.setAttribute('aria-label', '');
            }

            setDisplay(true);
            onKeyUp(e.currentTarget.value);
        }
    };

    const handleFormClick = (e) => {
        e.stopPropagation();
        setDisplay(true);
    };

    const handleOnChange = (e) => {
        setValue(e.target.value);
    };

    const focusInput = () => {
        inputRef?.current?.focus();
    };

    const clearInput = () => {
        setValue('');
        onKeyUp('');
        focusInput();
        setDisplay(false);
    };

    const inputSetDisplay = function () {
        setDisplay(false);
    };

    window.removeEventListener('click', inputSetDisplay);
    window.addEventListener('click', inputSetDisplay);
    document.removeEventListener('closeAutocomplete', inputSetDisplay);
    document.addEventListener('closeAutocomplete', inputSetDisplay);

    const renderForm = () => (
        <form role={'search'} aria-label={'Website durchsuchen'} className={'magat cmp-form'} onClick={handleFormClick}
              onSubmit={onSubmit}>
            <label htmlFor={'searchInput'} className={'sr-only'}>Suche</label>
            <input className={'cmp-search__input'}
                   type={"text"}
                   autoComplete="off"
                   id={'searchInput'}
                   spellCheck={'false'}
                   ref={inputRef}
                   placeholder={placeholder}
                   value={value}
                   onFocus={handleFormClick}
                   onKeyUp={handleKeyUp}
                   onKeyDown={handleKeyDown}
                   onChange={handleOnChange}/>
            {value.trim().length > 0
                && <button className={'magenta-icon-close cmp-search__clear-input'} aria-label={searchCancelAlt} type={'button'} onClick={clearInput}/>}
            <button className={'cmp-search__button magat-btn'} type="submit" aria-label={searchButtonAlt}>
                <span className="magenta-icon-search magat-btn__icon-left"></span>
                <span className={'cmp-search__button-label'}>{buttonLabel}</span>
            </button>
            {(autocompleteResultProducts?.length > 0 || autocompleteResultPages?.length > 0) && displayAutocomplete
                && <React.Fragment>
                    <Autocomplete insideHeader={insideHeader}
                                  itemsProducts={autocompleteResultProducts}
                                  itemsPages={autocompleteResultPages}
                                  query={query}
                                  inputValue={value}
                                  clickAction={clickAutocomplete}
                                  submitAction={submitAutocomplete}/>
                </React.Fragment>}
        </form>
    );

    return (
        <React.Fragment>
            {
                insideHeader && !renderStatic
                    ? <div className={`cmp-search__animationContainer ${visible === true ? 'slideIn' : visible === false ? 'slideOut' : ''}`}>
                        {renderForm()}
                    </div> : renderForm()
            }
        </React.Fragment>
    );
};

export default Input;
